var StickyFooter = function() {

  var Header = document.querySelector("header .header, header.lottery-header"),
    Footer = document.querySelector("footer.footer"),
    MainSection = document.querySelector("main"),
    HeaderHeight = Header?.offsetHeight ?? 0,
    FooterHeight = Footer?.offsetHeight ?? 0,
    calc = "calc(100vh - " + (HeaderHeight + FooterHeight) + "px)";

  if(MainSection) {
    MainSection.style.setProperty("min-height", calc);
  }

};

export {StickyFooter};